/**
 * Resolve both a relative and absolute route to the same type.
 *
 * This is useful when trying to resolve redirection urls as:
 * - locally, an absolute route is defined in ENV since apps are on different ports
 * - every other environment will define a relative route in the ENV.
 *
 * An absolute route will be returned as is.
 * A relative route will be appended to the window location and returned as an absolute route.
 *
 * @param route Either an absolute or relative route
 * @returns {*|string}
 */
export default function resolveLocalRoute(route) {
  return route.includes('http://')
    ? route
    : `${window.location.origin}${route}`;
}
